export const tenantcantons: { [key: string]: string } = {
  tagesanzeiger: 'ZH',
  bernerzeitung: 'BE',
  bazonline: 'BS',
  langenthalertagblatt: 'BE',
  zsz: 'ZH',
  landbote: 'ZH',
  berneroberlaender: 'BE',
  tdg: 'GE',
  '24heures': 'VD'
}
export const tenantlanguage: { [key: string]: string } = {
  tagesanzeiger: 'DE',
  bernerzeitung: 'DE',
  bazonline: 'DE',
  langenthalertagblatt: 'DE',
  zsz: 'DE',
  landbote: 'DE',
  berneroberlaender: 'DE',
  tdg: 'FR',
  '24heures': 'FR'
}
